var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.content && _vm.data.content.length > 0)?_c('div',{staticClass:"C-block-type-19"},[(_vm.type === 'grid')?_c('BlockType19Grid',{attrs:{"data":_vm.data,"settings":_vm.settings}}):_c('BlockType19List',{attrs:{"data":_vm.data,"settings":_vm.settings}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }